import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { AntiguedadSaldos } from "./form";
const AntiguedadSaldosFormRx = componentToRx(AntiguedadSaldos);

type Entity = models.FiltroAntiguedadSaldos;
const resource = resources.AntiguedadSaldos;

export interface State {
    value: Entity;
}

class AntguedadSaldosEditComp extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    get rules(): validation.Rules<Entity> {
        return {
            FechaCorte: validation.required,
            IdCliente: validation.required
        };
    }
    errors = () => validation.getErrors(this.rules, this.state.value);

    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x }, () => console.log(this.state))
    }), this.errors);

   // onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onGenerarAntiguedadSaldos = async () => {
        console.log(this.state);
        const reporte = await resources.AntiguedadSaldos.GenerarReporteAntiguedad(this.state.value);
        //await kea.download(reporte, "Saldo cartera.xls");
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte de antiguedad de saldos.xls");
    }

    onGenerarEdoCuenta = async () => {
        console.log(this.state);
        const reporte = await resources.AntiguedadSaldos.GenerarEdoCuenta(this.state.value);
        //await kea.download(reporte, "Saldo cartera.xls");
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte estado de cuenta.xls");
    }

    onGenerarEdoCuentaDetallado = async () => {
        console.log(this.state);
        const reporte = await resources.AntiguedadSaldos.GenerarEdoCuentaDetallado(this.state.value);
        //await kea.download(reporte, "Saldo cartera.xls");
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte estado de cuenta detallado.xls");
    }

    render() {
        /* return <AntiguedadSaldosFormRx
            value={this.state.value}
            onChange={this.onChange}
            onGenerar={this.onGenerar} />; */

            const getField = this.getField;
            const Cliente = getField(selectores.Cliente);
            const DateTime = getField(kea.DateTime);

            return (
                <div>
                    <kea.Title titulo="Antigüedad de saldos" onRegresar={() => history.go("../")} />
                    {kea.autogrid(6, [
                        <DateTime field="FechaCorte" label="Fecha de Corte:" />,
                        <Cliente field="IdCliente" label="Cliente:" />,
                        
                    ])}
    
                    <div className="row">
                        <div className="col-md-12">
                            {/* <kea.Button children="Genrar reporte" onClick={this.onGenerar} style="success" /> */}
                            <kea.Button children="Edo Cuenta" style="success" onClick={this.onGenerarEdoCuenta} disabled={validation.hasError(this.errors())} />
                            <kea.Button children="Edo Cuenta Detallado" style="success" onClick={this.onGenerarEdoCuentaDetallado} disabled={validation.hasError(this.errors())} />
                        </div>
                    </div>
                </div>);
    }
}

export const AntguedadSaldosEdit = withRouter(AntguedadSaldosEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteestadodecuenta/edit/edit.tsx